import { render, staticRenderFns } from "./DeleteCustomViews.vue?vue&type=template&id=78795271&"
import script from "./DeleteCustomViews.vue?vue&type=script&lang=js&"
export * from "./DeleteCustomViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78795271')) {
      api.createRecord('78795271', component.options)
    } else {
      api.reload('78795271', component.options)
    }
    module.hot.accept("./DeleteCustomViews.vue?vue&type=template&id=78795271&", function () {
      api.rerender('78795271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/customviews/DeleteCustomViews.vue"
export default component.exports